const KERCHIEF_HATS = [
  {
    slug: "kerchief-black-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 5
      },
      {
        stat: "blackRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-blue-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-green-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-orange-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-pink-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-purple-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-red-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "redRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "kerchief-yellow-8",
    name: "Kerchief",
    description: "Handy for spills",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 8
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  KERCHIEF_HATS
};
//# sourceMappingURL=data:application/json;base64,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
